import React, { useState } from 'react';
import SubmitButton from '../../../components/Common/SubmitButton';

interface ProjectTemplateFormValues {
  id?: string;
  wpProjectId: string;
}

interface ProjectTemplateFormProps {
  setShowForm: (value: boolean) => void;
  templateDetails: ProjectTemplateFormValues | null;
  onSave: (data: ProjectTemplateFormValues) => Promise<void>;
}

const ProjectTemplateForm: React.FC<ProjectTemplateFormProps> = ({
  setShowForm,
  templateDetails,
  onSave,
}) => {
  const isEdit = !!templateDetails?.id;
  const [loader, setLoader] = useState(false);
  const [form, setForm] = useState<ProjectTemplateFormValues>({
    id: templateDetails?.id || undefined,
    wpProjectId: templateDetails?.wpProjectId || '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoader(true);
    try {
      await onSave(form);
    } finally {
      setLoader(false);
    }
  };

  const isValid = !!form.wpProjectId;

  return (
    <div className="bg-white rounded-lg p-6 max-w-xl">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-gray-800">
          {isEdit ? 'Edit' : 'Create'} Project
        </h2>
        <button
          onClick={() => setShowForm(false)}
          className="text-gray-500 hover:text-gray-700 text-2xl leading-none"
        >
          &times;
        </button>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div>
          <label htmlFor="wpProjectId" className="block text-sm font-medium text-gray-700 mb-1">
            WordPress Project ID *
          </label>
          <input
            type="text"
            id="wpProjectId"
            name="wpProjectId"
            value={form.wpProjectId}
            onChange={handleChange}
            placeholder="e.g. 10399"
            className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            required
          />
          <p className="text-xs text-gray-500 mt-1">
            All project data (name, description, dates, resources) will be fetched from WordPress automatically.
          </p>
        </div>

        <div className="flex justify-end gap-3 mt-2">
          <button
            type="button"
            onClick={() => setShowForm(false)}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
          >
            Cancel
          </button>
          <SubmitButton title={isEdit ? 'Update' : 'Create'} loader={loader} disable={!isValid} />
        </div>
      </form>
    </div>
  );
};

export default ProjectTemplateForm;
